import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-lives-count',
  templateUrl: './lives-count.component.html',
  styleUrls: ['./lives-count.component.scss']
})
export class LivesCountComponent implements OnInit {

  @Input() config;

  constructor() { }

  ngOnInit() {
  }

}
